import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

const hasChatWithAgentBtnClickedState = atom({
  key: 'hasChatWithAgentBtnClickedState',
  default: false,
});

export const useHasChatWithAgentBtnClicked = () =>
  useRecoilValue(hasChatWithAgentBtnClickedState);

export const useSetHasChatWithAgentBtnClicked = () =>
  useSetRecoilState(hasChatWithAgentBtnClickedState);
